export const projects = [
  {
    id: "01",
    title: "Digital Agency",
    desc: "Digital Agency Web Template",
    tech: ["React", "JS", "Framer Motion", "Responsive"],
    link: "https://agency-site-two-zeta.vercel.app",
    github: "https://github.com/sayed-kassem",
    img: "/agency.png",
    year: "2024",
    type: "WEB TEMPLATE",
  },
  {
    id: "02",
    title: "Lens Portfolio",
    desc: "Photography Portfolio Web Template",
    tech: ["React", "JS", "Framer Motion", "Responsive"],
    link: "https://lens-portfolio.vercel.app",
    github: "https://github.com/sayed-kassem",
    img: "/lens.png",
    year: "2024",
    type: "WEB TEMPLATE",
  },
  {
    id: "03",
    title: "Soundscape",
    desc: "Vue.js music player with modern UI and playlist management",
    tech: ["Vue.js", "JavaScript", "CSS3", "Web Audio API"],
    link: "https://soundscape-nu.vercel.app/",
    github: "https://github.com/sayed-kassem",
    img: "/music.png",
    year: "2024",
    type: "WEB APP",
  },
  {
    id: "04",
    title: "Lebanese Festival",
    desc: "WordPress site for Lebanese Festival in Halifax, Canada",
    tech: ["WordPress", "JS", "MySQL", "Responsive"],
    link: "https://LebaneseFestival.ca",
    github: "https://github.com/sayed-kassem",
    img: "https://lebanesefestival.ca/wp-content/uploads/2024/06/Lebfest-Logo-1536x781.png",
    year: "2024",
    type: "CMS / WEB",
  },
];

export const skills = ["React", "TypeScript", "Next.Js", "CSS", "Figma", "Android / Kotlin", "WordPress"];

export const services = [
  { label: "UI / UX DESIGN", num: "001" },
  { label: "WEB DEVELOPMENT", num: "002" },
  { label: "MOBILE APPS", num: "003" },
];
